import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

// When the session is gone for good, send the browser to the login page once.
// Without this a dead session left every open page throwing errors at the
// user while still looking signed in — the refresh failed, the original
// request was rejected, and nothing told anybody why.
const redirectToLogin = () => {
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401 || !originalRequest || originalRequest._retry) {
      return Promise.reject(error);
    }

    // Don't intercept auth endpoints themselves
    const url = originalRequest.url || "";
    if (
      url.includes("/auth/login") ||
      url.includes("/auth/refresh") ||
      url.includes("/auth/2fa") ||
      url.includes("/auth/me")
    ) {
      return Promise.reject(error);
    }

    // Marked before the queued branch as well as after it. Queued requests
    // used to be replayed without the flag, so a second 401 from any of them
    // started another refresh round — and on a page issuing several calls at
    // once that became a loop.
    originalRequest._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => axios(originalRequest));
    }

    isRefreshing = true;

    try {
      await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
      processQueue(null);
      return axios(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError);
      redirectToLogin();
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);
